import SaveInProgressIntro from 'platform/forms/save-in-progress/SaveInProgressIntro';
import { isLoggedIn } from 'platform/user/selectors';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import content from '../../../locales/en/content.json';
import CheckAppStatusAlert from '../../FormAlerts/CheckAppStatusAlert';
import ProcessTimeline from './ProcessTimeline';

const ProcessDescription = ({ route }) => {
  const { formConfig, pageList } = route;
  const { formId, prefillEnabled, savedFormMessages } = formConfig;

  const isLoggedOut = !useSelector(isLoggedIn);
  const sipProps = useMemo(
    () => ({
      headingLevel: 2,
      messages: savedFormMessages,
      startText: content['sip-start-form-text'],
      formConfig,
      formId,
      pageList,
      prefillEnabled,
    }),
    [formConfig, formId, pageList, prefillEnabled, savedFormMessages],
  );

  return (
    <>
      <p className="va-introtext vads-u-margin-bottom--4">
        VA healthcare covers care for your physical and mental health. This
        includes a range of services from checkups to surgeries to home
        healthcare. It also includes prescriptions and medical equipment. Apply
        online now.
      </p>

      {isLoggedOut && <CheckAppStatusAlert />}

      <ProcessTimeline />
      <SaveInProgressIntro {...sipProps} />
    </>
  );
};

ProcessDescription.propTypes = {
  route: PropTypes.shape({
    formConfig: PropTypes.shape({
      formId: PropTypes.string,
      prefillEnabled: PropTypes.bool,
      savedFormMessages: PropTypes.object,
    }),
    pageList: PropTypes.array,
  }),
};

export default ProcessDescription;
